(function () {
    'use strict';

    angular.module('sempraWebapp').factory('ComparationReportViewModel', ComparationReportViewModelFactory);

    /** @ngInject */
    function ComparationReportViewModelFactory(reportActions, reportsFilterStore, localeFilters, dispatcher, ActionTypesEnum) {

        function ComparationReportViewModel() {
            this._reportsFilterStoreChangeHandler = null;
            this.chart = {
                data: null,
                x: {
                    tick: {
                        culling: { max: 15 },
                        rotate: 60,
                        format: function (item) {
                            return localeFilters.getMonthLocale(item);
                        }
                    }
                }
            };

            init.call(this);
        }

        ComparationReportViewModel.prototype.destroy = function () {
            reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        };

        return ComparationReportViewModel;

        function init() {
            var that = this;
            this.isChartVisible = false;

            searchByFilter.call(that);
            this._reportsFilterStoreChangeHandler = function () {
                searchByFilter.call(that);
            };

            reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        }

        function searchByFilter() {
            var that = this;

            // get all init data for filtering (default ones)
            var reportFilterData = reportsFilterStore.getFilterData();

            if (reportFilterData.selectedFacilitySerial) {
                // prepare data for chart legend (create group names / column / row names )
                this.period1 = '(' + reportFilterData.period2From + ') '
                    + localeFilters.getMonthLocale((reportFilterData.period1From - 1), false)
                    + ' - '
                    + localeFilters.getMonthLocale((reportFilterData.period1To - 1), false);
                this.period2 = '(' + reportFilterData.period2To + ') '
                    + localeFilters.getMonthLocale((reportFilterData.period1From - 1), false)
                    + ' - '
                    + localeFilters.getMonthLocale((reportFilterData.period1To - 1), false);

                reportActions.getComparationFinances(reportFilterData.selectedFacilitySerial, reportFilterData.period1From, reportFilterData.period1To, reportFilterData.period2From, reportFilterData.period2To).then(function (successData) {
                    successData.groupsData.sort(function(a,b){
                        return (a.groupValue > b.groupValue) ? 1 : -1;
                    });
                    successData.groupNames = [
                        that.period1,
                        that.period2
                    ];
                    successData.groupsData.forEach(function (group) {
                        group.groupValue -= 1;
                    });
                    that.chart.data = successData;
                    that.isChartVisible = (successData.total !== 0) ? true : false;
                    dispatcher.dispatch({
                        type: ActionTypesEnum.HIDE_LOADER
                    });
                });
            } else {
                that.isChartVisible = false;
            }

            return false;
        }


    }
})();
